/* 页面类型 */
export const RouteAuthRanges = {
	WX_ONLY: 1,	//微信专用
	NORMAL: 2,	//通用
	APP: 3		//App专用
}

/* 身份校验模式 */
export const AuthTypes = {
	H5: 'H5',
	WX: 'WX'
}

/* 容器内部排列方式 */
export const LayoutDirs = {
	HORI: 'HORI',
	VERT: 'VERT'
}

/* 接口数据返回状态 */
export const DaoStates = {
	SUCCESS: 'SUCCESS',
	FAILED: 'FAILED'
}

/* 加密类型 */
export const CrypticTypes = {
	BASE64: 'BASE64'	//base64加密
}

/* 路由切换动画效果 */
export const RouteEffectTypes = {
	NONE: 'NONE',					//无动画
	SLIDER_LEFT: 'SLIDER_LEFT',		//从右往左滑
	SLIDER_RIGHT: 'SLIDER_RIGHT'	//从左往右滑
}

/* Dialog类型 */
export const DialogTypes = {
	TOAST: 'TOAST',
	ALERT: 'ALERT',
	CONFIRM: 'CONFIRM',
	ACTIONSHEET: 'ACTIONSHEET',
	POP: 'POP',
	NOTIFY: 'NOTIFY'
}

/* ActionSheet弹出方向 */
export const ActionSheetDir = {
	TOP: 'TOP',
	BOTTOM: 'BOTTOM'
}

/* 文本输入框的水平对齐方式 */
export const TextAlignTypes = {
	LEFT: 'left',
	CENTER: 'center',
	RIGHT: 'right'
}

/* Popup框的弹出方向 */
export const PopupDir = {
	TOP: 'TOP',
	BOTTOM: 'BOTTOM',
	LEFT: 'LEFT',
	RIGHT: 'RIGHT'
}

/* 按钮的风格类型 */
export const ButtonTypes = {
	PRIMARY: 'PRIMARY',
	SUCCESS: 'SUCCESS',
	DANGER: 'DANGER',
	TEXT: 'TEXT',
	INFO: 'INFO'
}

/* 按钮的尺寸类型 */
export const ButtonSizeTypes = {
	LARGE: 'LARGE',
	MEDIUM: 'MEDIUM',
	SMALL: 'SMALL'
}

/* upload组件调用摄像头限制类型 */
export const CaptureTypes = {
	ALL: 'ALL',
	ONLY_CAMERA: 'ONLY_CAMERA'
}

/* upload组件接受上传文件的类型 */
export const UploadAccepts = {
	IMAGE: 'IMAGE',
	VIDEO: 'VIDEO',
	AUDIO: 'AUDIO'
}

/* 图片懒加载显示填充方式 */
export const ImageFitTypes = {
	NORMAL: 'NORMAL',
	COVER: 'COVER'
}

/* Tabs的内部排列方向 */
export const TabsDirTypes = {
	VERT: 'VERT',
	HORI: 'HORI'
}